import { format, isValid, parse, parseISO } from 'date-fns';


export const formatDateString = (dateValue, formatPattern) => {
  if (!dateValue) return "-";

  let date;

  // nếu là Date
  if (dateValue instanceof Date) {
    date = dateValue;
  }
  // nếu là string ISO
  else if (typeof dateValue === "string") {
    date = parseISO(dateValue);
  } else {
    return "-";
  }

  if (!isValid(date)) return "-";

  return format(date, formatPattern);
};

export const formatTimeString = (timeString, timeFormat) => {
   if (!timeString) return ''; // Handle null or undefined dates

   return format(new Date(timeString), `${timeFormat}`);
};

export const formatDateTimeString = (dateTimeString, dateFormat, timeFormat) => {
   if (!dateTimeString) return ''; // Handle null or undefined dates

   return format(new Date(dateTimeString), `${dateFormat} ${timeFormat}`);
};

export const formatStringToHourMiniteString = (timeString) => {
   if (!timeString) return '00:00'; // Handle null or undefined dates

   const [hours, minutes] = timeString.split(':');

   return `${hours}:${minutes}`;
};
